import { createStore } from 'vuex'
import menu from './modules/menu'

export default createStore({
  modules: {
    menu
  }
}) 
